"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddFiltersToggle = void 0;
var _Button = require("../../../elements/button/Button");
var _Pill = require("../../../elements/pill/Pill");
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _filterList = require("../../../assets/icons/filter-list.svg");
var _addFiltersToggleModule = _interopRequireDefault(require("./add-filters-toggle.module.scss"));
var AddFiltersToggle = function AddFiltersToggle(_ref) {
  var toggleAdditionalFilters = _ref.toggleAdditionalFilters,
    numberOfActiveAdditionalFilters = _ref.numberOfActiveAdditionalFilters;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _addFiltersToggleModule.default['add-filters-toggle']
  }, /*#__PURE__*/_react.default.createElement(_Button.LinkButton, {
    onClick: toggleAdditionalFilters,
    className: _addFiltersToggleModule.default['add-filters-toggle__button']
  }, /*#__PURE__*/_react.default.createElement(_filterList.ReactComponent, {
    className: _addFiltersToggleModule.default['add-filters-toggle__icon']
  }), ' ', t('addFiltersToggle.add')), numberOfActiveAdditionalFilters !== 0 && /*#__PURE__*/_react.default.createElement(_Pill.ActivePill, {
    className: _addFiltersToggleModule.default['add-filters-toggle__active-counter']
  }, numberOfActiveAdditionalFilters));
};
exports.AddFiltersToggle = AddFiltersToggle;